var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c(
      "nav",
      {
        staticClass: "breadcrumb is-small",
        attrs: { "aria-label": "breadcrumbs" }
      },
      [
        _c("ul", [
          _vm.userData.roleID !== "Customer"
            ? _c("li", [
                _c("a", { attrs: { href: "/project/" + _vm.projectID } }, [
                  _vm._v("Project: " + _vm._s(_vm.projectID))
                ])
              ])
            : _vm._e(),
          _vm.userData.roleID === "Customer"
            ? _c("li", [
                _c(
                  "a",
                  { attrs: { href: "/customer/project/" + _vm.projectID } },
                  [_vm._v("Project: " + _vm._s(_vm.projectID))]
                )
              ])
            : _vm._e(),
          _c("li", { attrs: { lass: "is-active" } }, [
            _c("a", { attrs: { href: "#", "aria-current": "page" } }, [
              _vm._v("Quotation: " + _vm._s(_vm.quNo))
            ])
          ])
        ])
      ]
    ),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-8" }, [
        _vm._m(0),
        _c("h3", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.quNo))]),
        _c("h3", { staticClass: "subtitle" }, [
          _vm._v("Revise : " + _vm._s(_vm.revise))
        ])
      ]),
      _vm._m(1)
    ]),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _vm._v("\n              Lead Time:\n          ")
        ]),
        _c("div", { staticClass: "column is-4" }, [
          _vm._v(
            "\n              " +
              _vm._s(_vm._f("Number")(_vm.quData.leadTime)) +
              "\n          "
          )
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _vm._v("\n              Amount (THB):\n          ")
        ]),
        _c("div", { staticClass: "column is-4" }, [
          _vm._v(
            "\n             " +
              _vm._s(_vm._f("Currency")(_vm.quData.amount)) +
              "\n          "
          )
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }, [
          _vm._v("\n              Quotation\n          ")
        ]),
        _c("div", { staticClass: "column is-4" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://api.musubi-thai.com/public/" +
                  _vm.quData.quPath +
                  _vm.quData.quotationFile
              }
            },
            [_c("i", { staticClass: "fa fa-download" }), _vm._v(" Download")]
          )
        ])
      ])
    ]),
    _vm.quData.quotationTask.length > 0
      ? _c("div", [
          _c("table", { staticClass: "table" }, [
            _vm._m(2),
            _c(
              "tbody",
              _vm._l(_vm.quData.quotationTask, function(item) {
                return _c("tr", { key: item.taskName }, [
                  _vm._m(3, true),
                  _c("td", [_vm._v(_vm._s(item.taskName))]),
                  _c("td", [_vm._v(_vm._s(item.taskDetail))]),
                  _c("td", [_vm._v(_vm._s(_vm._f("Date")(item.estStartDate)))]),
                  _c("td", [_vm._v(_vm._s(_vm._f("Date")(item.estFinishDate)))])
                ])
              })
            )
          ])
        ])
      : _vm._e(),
    _vm.quData.quotationTask.length > 0
      ? _c("article", {}, [
          _vm._m(4),
          _c(
            "div",
            {},
            [_c("grantchart", { attrs: { tasks: _vm.quData.quotationTask } })],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "title" }, [
      _c("b", [_c("i", { staticClass: "fa fa-file" }), _vm._v(" Quotation")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-4" }, [
      _c("div", { staticClass: "is-pulled-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("Task Name")]),
        _c("th", [_vm._v("Task Detail")]),
        _c("th", [_vm._v("Est. Start Date")]),
        _c("th", [_vm._v("Est. Finish Date")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("i", { staticClass: "fa fa-tasks" }),
      _vm._v(" \n                  ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "message-section is-clearfix clear-margin-bottom" },
      [_c("p", [_vm._v("Task")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d7c9318", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7c9318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/quotation/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3d7c9318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/quotation/_id.vue
// module chunks = 43